import React from 'react';
interface StatusBarProps {
  projectId: string;
  customerId: string;
  status: (string | null)[];
}
export const StatusBar: React.FC<StatusBarProps> = ({
  projectId,
  customerId,
  status
}) => {
  return <div className="fixed bottom-0 left-0 right-0 bg-white shadow-md py-3 px-6 border-t border-gray-200" data-id="element-20">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-21">
        <div className="flex items-center space-x-4" data-id="element-22">
          <div className="text-sm" data-id="element-23">
            <span className="text-gray-500" data-id="element-24">Projekt:</span>
            <span className="ml-1 font-medium" data-id="element-25">{projectId}</span>
          </div>
          <div className="text-sm" data-id="element-26">
            <span className="text-gray-500" data-id="element-27">Kunde:</span>
            <span className="ml-1 font-medium" data-id="element-28">{customerId}</span>
          </div>
        </div>
        <div className="flex items-center space-x-3" data-id="element-29">
          {status.map((item, index) => item && <div key={index} className="px-3 py-1 bg-green-100 text-green-800 text-xs font-medium rounded-full" data-id="element-30">
                  {item}
                </div>)}
        </div>
        <div className="flex items-center space-x-3" data-id="element-31">
          <button className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md text-sm font-medium hover:bg-gray-300 transition-colors" data-id="element-32">
            Gem kladde
          </button>
          <button className="px-4 py-2 bg-[#E3000F] text-white rounded-md text-sm font-medium hover:bg-red-700 transition-colors" data-id="element-33">
            Overfør til tilbud
          </button>
        </div>
      </div>
    </div>;
};